import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { PreferenzaAmministratore } from 'src/app/models/preferenza-amministratore';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { PreferenzaAmministratoreService } from '../../services/preferenza-amministratore.service';
import { EditPreferenzaAmministratoreComponent } from './dialogs/edit/edit.component';

@Component({
  selector: 'preferenze-amministratori',
  templateUrl: './preferenze-amministratori.component.html',
  styleUrls: ['./preferenze-amministratori.component.scss']
})
export class PreferenzeAmministratoriComponent implements OnInit {

  headingText: string = 'Preferenze Amministratori';

  relations: string[] = ['altro_soggetto', 'compagnia', 'incaricato'];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'Amministratore',
        internalName: 'altro_soggetto',
        displayFunction: model => model?.altro_soggetto?.humanIdentifier
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Compagnia',
        internalName: 'compagnia',
        displayFunction: model => model?.compagnia?.humanIdentifier
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Incaricato',
        internalName: 'incaricato',
        displayFunction: model => model?.incaricato?.humanIdentifier
      }
    ),
  ];

  constructor(
    public preferenzaAmministratoreService: PreferenzaAmministratoreService,
    public dialog: MatDialog,
    private toast: ToastrService,
    private fb: FormBuilder,
    @Optional() private dialogRef: MatDialogRef<PreferenzeAmministratoriComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona una preferenza amministratore';
    }
  }

  form: FormGroup;

  ngOnInit() {
    this.form = this.fb.group({
      altro_soggetto: [],
      compagnia: [],
      incaricato: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);
  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }

  deleteFunction = async (preferenza: PreferenzaAmministratore) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Eliminare la preferenza per ${preferenza?.altro_soggetto?.humanIdentifier}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.preferenzaAmministratoreService.delete(preferenza);
          this.toast.success('Preferenza eliminata.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione preferenza fallita.", "Errore!");
    }
  }

  editFunction = async (preferenza: PreferenzaAmministratore) => {
    try {
      let dialogRef = this.dialog.open(EditPreferenzaAmministratoreComponent, { data: preferenza });
      dialogRef.afterClosed().subscribe(async (data: PreferenzaAmministratore) => {
        if (data) {
          Object.assign(preferenza, {
            ...data,
            altro_soggetto_id: data?.altro_soggetto?.id,
            compagnia_id: data?.compagnia?.id,
            incaricato_id: data?.incaricato?.id
          });

          await this.preferenzaAmministratoreService.edit(preferenza);

          this.toast.success('Preferenza aggiornata');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica preferenza fallita.", "Errore!");
    }
  }

  add() {
    let addDialogRef = this.dialog.open(EditPreferenzaAmministratoreComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(preferenza?: PreferenzaAmministratore) {
    if (preferenza) {
      try {
        await this.preferenzaAmministratoreService.create(preferenza)
        this.toast.success('Preferenza creata!')
      }
      catch (e) {
        this.toast.error('Creazione preferenza fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }
}
